// core version + navigation, pagination modules:
import Swiper, { Pagination, Navigation, Zoom } from "swiper";

export function zoomCarousel() {
    Swiper.use([Pagination, Navigation, Zoom]);

    // init Swiper:
    const zoomCarousel = new Swiper(".zoom-swiper", {
        // Optional parameters
        slidesPerView: 1,
        centeredSlides: true,
        zoom: true,
        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

document.querySelectorAll('.zoomBox').forEach(elem => {

    let x, y, width, height;
    
    elem.onmouseenter = () => {
    
      const size = elem.getBoundingClientRect();
    
      x = size.x;
      y = size.y;
      width = size.width;
      height = size.height;
    
    };
    
    elem.onmousemove = e => {
    
      const horizontal = (e.clientX - x) / width * 100;
      const vertical = (e.clientY - y) / height * 100;
    
      elem.style.setProperty('--x', horizontal + '%');
      elem.style.setProperty('--y', vertical + '%');
    
    };
    
});